// 字节数格式化为可读大小（B/KB/MB/GB/TB）。
export const formatBytes = (bytes: number | bigint): string => {
  if (bytes <= 0) return '0 B'
  const numericBytes = Number(bytes)
  const units = [
    'B',
    'KB',
    'MB',
    'GB',
    'TB',
  ]
  const i = Math.min(units.length - 1, Math.floor(Math.log(numericBytes) / Math.log(1024)))
  const value = numericBytes / 1024 ** i
  return `${value >= 10 || i === 0 ? Math.round(value) : value.toFixed(1)} ${units[i]}`
}
